// extracted by mini-css-extract-plugin
export default {"button":"HeaderCartBtn_button__BDOOq","icon":"HeaderCartBtn_icon__4Y5+1","badge":"HeaderCartBtn_badge__HFQRb","bump":"HeaderCartBtn_bump__szTbq"};